package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ClassConversationCreateRequest(
    val title: String,
    val description: String,
    @SerialName("class_section_id") val classSectionId: String? = null,
    @SerialName("student_id") val studentId: String? = null,
    @SerialName("attachment_url") val attachmentUrl: String? = null,
    @SerialName("attachment_filename") val attachmentFilename: String? = null,
    @SerialName("attachment_size_bytes") val attachmentSizeBytes: Int? = null
)

@Serializable
data class ClassConversationUpdateRequest(
    val title: String? = null,
    val description: String? = null,
    @SerialName("attachment_url") val attachmentUrl: String? = null,
    @SerialName("attachment_filename") val attachmentFilename: String? = null,
    @SerialName("attachment_size_bytes") val attachmentSizeBytes: Int? = null
)

@Serializable
data class ClassConversationReplyCreateRequest(
    @SerialName("reply_text") val replyText: String,
    @SerialName("attachment_url") val attachmentUrl: String? = null,
    @SerialName("attachment_filename") val attachmentFilename: String? = null
)

@Serializable
data class ClassConversationModerationActionRequest(
    val action: String,
    val reason: String? = null
)
